import { langName } from "./../pipe"
import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"

@NgModule({
    declarations: [langName],
    exports: [langName],
})
export class FilterModule {}
